export const competitorSides = {
  RED: 'red',
  BLUE: 'blue',
} as const;
